import { render, staticRenderFns } from "./applyPhone.vue?vue&type=template&id=5fa78ba9&scoped=true&"
import script from "./applyPhone.vue?vue&type=script&lang=js&"
export * from "./applyPhone.vue?vue&type=script&lang=js&"
import style0 from "./applyPhone.vue?vue&type=style&index=0&id=5fa78ba9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa78ba9",
  null
  
)

export default component.exports